import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineCheckpoints = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.3}
      d="M18.3 20.663a.787.787 0 1 0 1.575 0 .787.787 0 0 0-1.575 0ZM11.213 20.663a.787.787 0 1 0 1.574 0 .787.787 0 0 0-1.575 0ZM4.125 20.663a.787.787 0 1 0 1.574 0 .787.787 0 0 0-1.574 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="m2.55 11.213 6.3 5.512L21.45 2.55"
    />
  </svg>
);
export default SvgStreamlineCheckpoints;
